import React from "react";
import styled from "styled-components";

const Wrapper = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  height: 52px;
  padding: 0 22px;
  background: var(--lime);
  border: 1px solid var(--lime);
  border-radius: 8px;
  color: var(--ink);
  font-family: var(--fontBody);
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  svg {
    flex-shrink: 0;
    transition: transform 0.2s;
  }
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 28px rgba(184, 242, 61, 0.28);
    svg {
      transform: scale(1.2);
    }
  }
  &:focus-visible {
    outline: 2px solid var(--text);
    outline-offset: 3px;
  }
`;

function Button(props) {
  return (
    <Wrapper
      as={props.href ? "a" : "button"}
      href={props.href}
      target={props.target}
      rel={props.target === "_blank" ? "noreferrer" : undefined}
      onClick={props.onClick}
    >
      {props.children}
      {props.icon}
    </Wrapper>
  );
}

export default Button;
